import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../../../../../core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from '../../../../../core/services/project.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-edit-package',
    templateUrl: './edit-package.component.html',
    styleUrls: ['./edit-package.component.scss']
})

export class EditPackageComponent implements OnInit {
    geoCoder: any;
    selectedLat: any;
    selectedLng: any;
    highestRole: any;
    reactiveForm: FormGroup;
    isSubmitted: any;

    projectId: any;
    project: any;
    projectStatus: any;
    isLoading: boolean;

    startTimestamp = '';
    endTimestamp = '';
    sunsetTimestamp = '';
    tabIndex: number;

    selectedUsers = [];
    selectedUserIds = [];

    isUpdating: any;

    tags = [];
    indoorFeatures = [];
    outdoorFeatures = [];
    energyFeatures = [];
    selectedFeatureIdArray = [];

    onlyNumberRegex = /^[0-9]*$/;


    private incentive = new Array(5);


    public style = 'padding: 12px 10px; border: 0; width: calc(100% - 20px); outline: none; borderRadius: 4px;background:#161616;';


    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<any>, private fb: FormBuilder,
        private cdr: ChangeDetectorRef,
        private http: HttpService,
        private router: Router,
        private route: ActivatedRoute,
        private projectService: ProjectService,
        private toastrService: ToastrService) {
        this.projectStatus = [
            {
                name: 'Off market', value: 1
            }, {
                name: 'Off the plan', value: 2
            }, {
                name: 'Under construction', value: 3
            }, {
                name: 'Complete', value: 4
            }
        ];
        this.isLoading = true
        this.reactiveForm = this.fb.group({
            pname: [''],
            ptype: [''],
            website: [''],
            totalUnit: [''],
            vrUrl: [''],
            introductionEN: ['', [Validators.maxLength(2000)]],
            introductionZH: ['', [Validators.maxLength(2000)]],
            addressLine1: [''],
            // addressLine2: [''],
            area: [{ value: '', disabled: true }],
            city: [{ value: '', disabled: true }],
            state: [{ value: '', disabled: true }],
            postCode: [{ value: '', disabled: true }],
            country: [{ value: '', disabled: true }],
            // status: [''],
            firb: [''],
            commission: ['', [Validators.pattern(this.onlyNumberRegex)]],
            commissionUnit: [{ value: '%', disabled: false }],
            pstatus: [''],
            startDate: [{ value: '', disabled: true }],
            endDate: [{ value: '', disabled: true }],
            sunsetDate: [{ value: '', disabled: true }],
            projectStatus: [''],
            incentive1: [{ value: '', disabled: false }],
            incentive2: [{ value: '', disabled: false }],
            incentive3: [{ value: '', disabled: false }],
            incentive4: [{ value: '', disabled: false }],
            incentive5: [{ value: '', disabled: false }],
            tags: [''],
            cityCouncil: [''],
            lat: [''],
            lng: ['']
        });

    }

    ngOnInit(): void {
        console.log(this.data.packageProject);
        this.project = this.data.packageProject;
        if (this.project.tags) {
            this.project.tags.map((tag) => {
                this.selectedFeatureIdArray.push(tag.id);
            });
            console.log(this.selectedFeatureIdArray);
        }
        const projectType = [];
        this.project.projectTypes.map(type => {
            projectType.push(type.id);
        });
        console.log(projectType);
        this.http.getAllTagsByUser().subscribe((r: any) => {
            console.log(r);
            this.tags = r.data;
            this.indoorFeatures = r.data.filter(feature => feature.type === 1);
            this.outdoorFeatures = r.data.filter(feature => feature.type === 2);
            this.energyFeatures = r.data.filter(feature => feature.type === 3);
        });
        this.reactiveForm.patchValue({
            pname: this.project.name,
            ptype: projectType[0],
            website: this.project.website ? this.project.website : '',
            vrUrl: this.project.vrURLs ? this.project.vrURLs : '',
            totalUnit: this.project.totalUnit ? this.project.totalUnit : '',
            pstatus: this.project.projectStatus,
            // status: this.project.status,
            firb: this.project.firb,
            startDate: this.project.startTime ? new Date(this.project.startTime) : '',
            endDate: this.project.endTime ? new Date(this.project.endTime) : '',
            sunsetDate: this.project.sunsetTime ? new Date(this.project.sunsetTime) : '',
            // incentive: this.project.incentive ? JSON.parse(this.project.incentive) : '',
            incentive1: this.project.incentive ? this.project.incentive[0] : '',
            incentive2: this.project.incentive ? this.project.incentive[1] : '',
            incentive3: this.project.incentive ? this.project.incentive[2] : '',
            incentive4: this.project.incentive ? this.project.incentive[3] : '',
            incentive5: this.project.incentive ? this.project.incentive[4] : '',
            commission: this.project.commissionFee ? this.project.commissionFee : '',
            commissionUnit: this.project.commissionFeeUnit ? this.project.commissionFeeUnit : '%',
            introductionEN: this.project.notes ? this.project.notes.en : '',
            introductionZH: this.project.notes ? this.project.notes.zh : '',
            // addressLine1: this.project.addressLine1 ? this.project.addressLine1 : '',
            addressLine1: this.project.addressLine2 ? this.project.addressLine2 : '',
            area: this.project.area,
            state: this.project.state,
            city: this.project.city,
            postCode: this.project.postCode,
            country: this.project.country,
            lat: this.project.latitude,
            lng: this.project.longitude,
            cityCouncil: this.project.cityCouncil ? this.project.cityCouncil : ''
        });
        this.isLoading = false

    }

    getAddress(address: any) {
        console.log(address);
        const components = address.address_components;
        let addressLine2 = '';
        let area = '';
        let city = '';
        let state = '';
        let country = '';
        let postCode = '';
        components.forEach((component: { long_name: string; short_name: string; types: Array<string> }) => {
            if (component.types.find(type => type === 'street_number')) {
                addressLine2 = component.long_name;
            } else if (component.types.find(type => type === 'route')) {
                addressLine2 += ' ' + component.long_name;
            } else if (component.types.find(type => type === 'locality')) {
                area = component.long_name;
            } else if (component.types.find(type => type === 'administrative_area_level_2')) {
                city = component.short_name;
            } else if (component.types.find(type => type === 'administrative_area_level_1')) {
                state = component.short_name;
            } else if (component.types.find(type => type === 'country')) {
                country = component.long_name;
            } else if (component.types.find(type => type === 'postal_code')) {
                postCode = component.long_name;
            }
        });
        // console.log(address);
        this.reactiveForm.get('addressLine1').setValue(addressLine2);
        this.reactiveForm.get('area').setValue(area);
        this.reactiveForm.get('city').setValue(city);
        this.reactiveForm.get('state').setValue(state);
        this.reactiveForm.get('country').setValue(country);
        this.reactiveForm.get('postCode').setValue(postCode);
        this.getCoordinatesFromAddress(this.reactiveForm.get('addressLine1').value + ' ' + this.reactiveForm.get('area').value + ' ' + this.reactiveForm.get('city').value + ' ' + this.reactiveForm.get('postCode').value)
            .subscribe((coordinate: any) => {
                console.log(coordinate);
                this.selectedLat = coordinate.lat;
                this.selectedLng = coordinate.lng;
                this.reactiveForm.patchValue({
                    lat: coordinate.lat,
                    lng: coordinate.lng
                });
                this.cdr.detectChanges();
                // fd.append('latitude', coordinate.lat);
                // fd.append('longitude', coordinate.lng);
            });

        this.cdr.detectChanges();

    }
    close() {
        this.dialogRef.close();
    }

    // 将起始时间转换成时间戳
    getStartDate(event) {
        this.startTimestamp = new Date(event.value).getTime().toString();
    }

    // 将结束时间转换成时间戳
    getEndDate(event) {
        this.endTimestamp = new Date(event.value).getTime().toString();
    }

    // 将sunset时间转换成时间戳
    getSunsetDate(event) {
        this.sunsetTimestamp = new Date(event.value).getTime().toString();
    }

    onSubmit() {
        // 项目 status -2隐藏删除 -1 待验证 0禁用 1.有效
        if (this.reactiveForm.invalid) {
            return;
        }
        const fd = new FormData();
        fd.append('projectTypeIds', this.reactiveForm.get('ptype').value.toString());

        if (this.reactiveForm.get('pname').value !== this.project.name) {
            fd.append('name', this.reactiveForm.get('pname').value);
        }

        if (this.reactiveForm.get('pstatus').value !== this.project.projectStatus) {
            fd.append('projectStatus', this.reactiveForm.get('pstatus').value);
        }

        if (this.reactiveForm.get('commission').value !== this.project.commissionFee && this.reactiveForm.get('commission').value) {
            fd.append('commissionFee', this.reactiveForm.get('commission').value);
        }

        if (this.reactiveForm.get('firb').value !== this.project.firb) {
            fd.append('firb', this.reactiveForm.get('firb').value);
        }
        if ((this.reactiveForm.get('website').value !== this.project.website) && this.reactiveForm.get('website').value) {
            fd.append('website', this.reactiveForm.get('website').value);
        }

        if ((this.reactiveForm.get('totalUnit').value !== this.project.totalUnit) && this.reactiveForm.get('totalUnit').value) {
            fd.append('totalUnit', this.reactiveForm.get('totalUnit').value);
        }

        if ((this.reactiveForm.get('vrUrl').value !== this.project.vrURLs) && this.reactiveForm.get('vrUrl').value) {
            fd.append('vrURLs', this.reactiveForm.get('vrUrl').value);
        }

        // if (this.reactiveForm.get('introductionEN').value !== this.project.notes.en || this.reactiveForm.get('introductionZH').value !== this.project.notes.zh) {
        fd.append('notes', JSON.stringify({
            zh: this.reactiveForm.get('introductionZH').value,
            en: this.reactiveForm.get('introductionEN').value,
        }));
        // }

        // if (this.selectedLat && this.selectedLat !== this.project.latitude) {
        fd.append('latitude', this.reactiveForm.get('lat').value);
        // }

        // if (this.selectedLng && this.selectedLng !== this.project.longitude) {
        fd.append('longitude', this.reactiveForm.get('lng').value);
        // }
        console.log(this.project.startTime);
        console.log(this.reactiveForm.get('startDate').value);
        if (this.reactiveForm.get('startDate').value && this.reactiveForm.get('startDate').value.getTime() !== this.project.startTime) {
            fd.append('startTime', this.reactiveForm.get('startDate').value.getTime().toString());
        }

        console.log(this.reactiveForm.get('endDate'));
        if (this.reactiveForm.get('endDate').value && this.reactiveForm.get('endDate').value.getTime() !== this.project.endTime) {
            fd.append('endTime', this.reactiveForm.get('endDate').value.getTime().toString());
        }

        if (this.reactiveForm.get('sunsetDate').value && this.reactiveForm.get('sunsetDate').value.getTime() !== this.project.sunsetTime) {
            fd.append('sunsetTime', this.reactiveForm.get('sunsetDate').value.getTime().toString());
        }

        if (this.reactiveForm.get('cityCouncil').value) {
            fd.append('cityCouncil', this.reactiveForm.get('cityCouncil').value);
        }


        // fd.append('startTime', this.startTimestamp this.reactiveForm.get('startDate').value);
        // fd.append('endTime', this.endTimestamp);
        // fd.append('sunsetTime', this.sunsetTimestamp);

        const length = this.incentive.length;
        for (let i = 0; i < length; i++) {
            const value = this.reactiveForm.get('incentive' + (i + 1)).value;
            if (value) {
                this.incentive[i] = value;
            }
        }
        const hasIncentive = this.incentive.filter((i) => {
            return i !== null;
        }).length > 0;
        if (hasIncentive) {
            fd.append('incentive', JSON.stringify(this.incentive));
        }


        if (this.reactiveForm.get('addressLine1').value !== this.project.addressLine2) {
            fd.append('addressLine2', this.reactiveForm.get('addressLine1').value);
        }

        // if (this.reactiveForm.get('addressLine2').value !== this.project.addressLine2) {
        //   fd.append('addressLine2', this.reactiveForm.get('addressLine2').value);
        // }

        if (this.reactiveForm.get('postCode').value !== this.project.postCode) {
            fd.append('postCode', this.reactiveForm.get('postCode').value);
        }

        if (this.reactiveForm.get('area').value !== this.project.area) {
            fd.append('area', this.reactiveForm.get('area').value);
        }

        if (this.reactiveForm.get('city').value !== this.project.city) {
            fd.append('city', this.reactiveForm.get('city').value);
        }

        if (this.reactiveForm.get('state').value !== this.project.state) {
            fd.append('state', this.reactiveForm.get('state').value);
        }

        if (this.reactiveForm.get('country').value !== this.project.country) {
            fd.append('country', this.reactiveForm.get('country').value);
        }

        if (this.selectedUserIds.length > 0) {
            fd.append('userIds', this.selectedUserIds.toString());
        }

        // fd.append('status', this.reactiveForm.get('status').value);

        if (this.selectedFeatureIdArray.length > 0) {
            fd.append('tagIds', this.selectedFeatureIdArray.toString());
        }
        this.isUpdating = true;
        this.http.updateProject(fd, this.project.id).subscribe((r: any) => {
            console.log(r);
            if (r.code === 1) {
                this.projectService.projects = null;
                this.toastrService.success('Project updating successful.');
                this.isUpdating = false;
                this.dialogRef.close({ result: r.data });
                // window.location.reload();

            } else if (r.code === 0) {
                this.toastrService.error('Because the project is ' + (this.project.status === 0 ? 'deactivated' : 'being verified'), 'Failed to update project.');
                this.isUpdating = false;
            }
        });

        // console.log(this.reactiveForm.get('startDate').value);

    }

    isCheckBoxSelected(productId: number) {
        return this.selectedFeatureIdArray.includes(productId);
    }

    select(event: MatCheckboxChange, productId) {
        console.log(this.tags);
        if (event.checked) {
            this.selectedFeatureIdArray.push(productId);
            // if (this.selectedProductIdArray.length >= 2) {
            //     this.canCombine = true;
            // }
        } else {
            const index = this.selectedFeatureIdArray.indexOf(productId);
            this.selectedFeatureIdArray.splice(index, 1);
            // if (this.selectedProductIdArray.length < 2) {
            //     this.canCombine = false;
            // }
        }
        console.log(this.selectedFeatureIdArray);
    }

    public getCoordinatesFromAddress(address) {
        this.geoCoder = new google.maps.Geocoder();
        return new Observable((observer => {
            this.geoCoder.geocode({ 'address': address }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    // // console.log(results[0].geometry.location)
                    observer.next({
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng()
                    });
                } else {
                    // // console.log('Error - ', results, ' & Status - ', status);
                    observer.next({ lat: 0, lng: 0 });
                }
                observer.complete();
            });
        }));
    }


}
